"use strict";
import c from "./index.es105.js";
class u {
  constructor(s) {
    if (typeof s != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(n) {
      t = n;
    });
    const e = this;
    this.promise.then((n) => {
      if (!e._listeners) return;
      let r = e._listeners.length;
      for (; r-- > 0; )
        e._listeners[r](n);
      e._listeners = null;
    }), this.promise.then = (n) => {
      let r;
      const i = new Promise((o) => {
        e.subscribe(o), r = o;
      }).then(n);
      return i.cancel = function() {
        e.unsubscribe(r);
      }, i;
    }, s(function(n, r, i) {
      e.reason || (e.reason = new c(n, r, i), t(e.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(s) {
    if (this.reason) {
      s(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(s) : this._listeners = [s];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(s) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(s);
    t !== -1 && this._listeners.splice(t, 1);
  }
  toAbortSignal() {
    const s = new AbortController(), t = (e) => {
      s.abort(e);
    };
    return this.subscribe(t), s.signal.unsubscribe = () => this.unsubscribe(t), s.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let s;
    return {
      token: new u(function(t) {
        s = t;
      }),
      cancel: s
    };
  }
}
export {
  u as default
};
//# sourceMappingURL=index.es106.js.map
